import LocalShipping from "@mui/icons-material/LocalShipping";

import { SAVE_BEFORE_ACTING } from "./shipmentDisplay";
import { LifecycleStepKey } from "./shipmentLifecycle";
import { StepAction } from "./StepAction";

/**
 * The saved-state moves available from the rail, each keyed to the step it
 * advances so the rail can render it under that step.
 *
 * Keyed to the status, not to edit mode: these act on what is already
 * persisted, so hiding them until someone clicks Edit would make reviewing a
 * requested shipment and shipping it two separate errands. Pending edits
 * disable them, with the reason, rather than removing them.
 */
export function shipmentStepActions({
  canEdit,
  isDraft,
  hasUnsaved,
  onRequestPickup,
  onMarkShipped,
}: {
  canEdit: boolean;
  isDraft: boolean;
  hasUnsaved: boolean;
  onRequestPickup: () => void;
  onMarkShipped: () => void;
}): Partial<Record<LifecycleStepKey, React.ReactNode>> {
  if (!canEdit) {
    return {};
  }
  const blocked = hasUnsaved ? SAVE_BEFORE_ACTING : "";
  return {
    // Only a draft offers this as its next step. Once the vendor holds the
    // request, re-sending it is an overflow-menu action instead.
    ...(isDraft
      ? {
          request: (
            <StepAction label="Request pickup" blocked={blocked} onClick={onRequestPickup} />
          ),
        }
      : {}),
    shipped: (
      <StepAction
        label="Mark shipped"
        icon={<LocalShipping />}
        blocked={blocked}
        onClick={onMarkShipped}
      />
    ),
  };
}
